import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bb-file-attachment-page-ui',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FileAttachmentPageComponent {}
